import React from 'react';
import './Resources.css';

const Resources = () => {
    const resourceCards = [
        {
            title: 'Google Scholar Profile',
            type: 'Research profile',
            description:
                'Indexed books, chapters, citations, and research-style publications.',
            href: 'https://scholar.google.com/citations?hl=en&user=KCXLUtIAAAAJ',
            action: 'View Google Scholar Profile →',
            isExternal: true
        },
        {
            title: 'Collaboration & Advisory',
            type: 'Professional conversations',
            description:
                'Open to meaningful conversations around architecture advisory, engineering enablement, product platforms, education technology, and software delivery partnerships.',
            href: 'mailto:hello@ashutosh.net.in?subject=Collaboration%20Conversation',
            action: 'Start a Conversation →',
            isExternal: false
        }
    ];

    const resourceTypes = [
        'Whitepapers',
        'Architecture templates',
        'Book companion material',
        'Decks',
        'Citation-ready PDFs'
    ];

    return (
        <section id="resources" className="resources">
            <div className="resources-inner">
                <div className="section-kicker">Resources</div>
                <div className="resources-header">
                    <div>
                        <h2>Reference Material for Builders and Leaders</h2>
                        <p>
                            This section will host selected whitepapers, architecture
                            templates, book companion material, and citation-ready PDFs as
                            they are published.
                        </p>
                    </div>
                    <a
                        href="mailto:hello@ashutosh.net.in?subject=Resource%20Request"
                        className="resources-request"
                    >
                        Request a Resource →
                    </a>
                </div>

                <div className="resources-layout">
                    <div className="resource-card-grid">
                        {resourceCards.map((resource) => (
                            <article className="resource-action-card" key={resource.title}>
                                <span>{resource.type}</span>
                                <h3>{resource.title}</h3>
                                <p>{resource.description}</p>
                                <a
                                    href={resource.href}
                                    {...(resource.isExternal
                                        ? { target: '_blank', rel: 'noopener noreferrer' }
                                        : {})}
                                    aria-label={`${resource.action}: ${resource.title}`}
                                >
                                    {resource.action}
                                </a>
                            </article>
                        ))}
                    </div>

                    <div className="resource-library-note">
                        <h3>Growing Resource Library</h3>
                        <p>
                            The library will stay curated rather than crowded, with only
                            selected material added when it is ready to be useful, reusable,
                            and easy to reference.
                        </p>
                        <div className="resource-type-list" aria-label="Planned resource types">
                            {resourceTypes.map((type) => (
                                <span key={type}>{type}</span>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Resources;
